<template>
	<div>
		<div class="pop-mask" @click="pop_close"></div>
		<transition name="show">
			<div class="pop-wrap" v-if="is_pop">
				<div class="pop-title-closed">
					<div class="pop-title">{{title}}</div>
					<div class="pop-closed iconfont icon-close" @click="pop_close"></div>
				</div>
				<div class="pop-container">
					<slot></slot>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
	export default {
		name : "layer-pop",
		props : {
			title : {type : String, default:''},
			keyWord : {type : String, default : ''},
		},
		data (){
			return {
				is_pop : false
			}
		},
		mounted : async function(){
			let that = this;
			setTimeout(function  (){
				that.is_pop = true;
			},10);
		},
		methods : {
			pop_close : function (){
				let that = this;
				this.is_pop = false;
				setTimeout(function  (){
					if (that.keyWord){
						that.$emit('close', {keyword : that.keyWord, show : false});
					}else{
						that.$emit('close',false);
					}
				},510);
			}
		},
	}
</script>

<style scoped>
	.pop-mask { position: fixed; z-index: 9999; left: 0; right: 0; top: 0; bottom: 0; background: rgba(0,0,0,0.2); }
	.pop-wrap { position: fixed; z-index: 10000; width: 1200px; height: 700px; background: #ffffff; border-radius: 5px;
    overflow:hidden; box-shadow: 0 0 30px #666666; left: 50%; top: 50%; margin-left: -600px; margin-top: -350px; }
	.pop-title-closed { height: 49px; line-height: 49px; border-bottom: 1px solid #dcdfe6; padding: 0 20px; display: flex; }
	.pop-title { flex: 1; padding-right: 20px; }
	.pop-closed { font-size: 24px; color: #999999; cursor: pointer; }
	.pop-container { width: 1160px; height: 610px; padding: 20px; overflow-x: hidden; overflow-y: auto; }

	.show-enter-active, .show-leave-active {
		transition: all 0.5s;
	}
	.show-enter, .show-leave-to {
		opacity: 0;
		transform: translateY(-50px);
	}
</style>
